import { useEffect, useState, createContext, useContext } from "react";
import api from "@/lib/api";

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    const load = () => api.get("/settings").then(({ data }) => setSettings(data)).catch(() => setSettings((s) => s || {}));
    load();
    const iv = setInterval(load, 20000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", () => { if (!document.hidden) load(); });
    return () => { clearInterval(iv); window.removeEventListener("focus", onFocus); };
  }, []);
  return <SettingsContext.Provider value={settings || {}}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
